import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { MapPin, Star, Waves } from 'lucide-react';

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="accueil" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background with overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-50 via-green-50 to-teal-50">
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-800/15 to-green-700/15"></div>
      </div>
      
      {/* Decorative elements */}
      <div className="absolute top-20 right-10 w-40 h-40 bg-gradient-to-br from-emerald-300/40 to-green-300/40 rounded-full blur-2xl"></div>
      <div className="absolute bottom-20 left-10 w-56 h-56 bg-gradient-to-br from-green-300/30 to-emerald-300/30 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 py-32 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-6 flex justify-center">
            <Badge variant="secondary" className="px-5 py-3 text-sm font-semibold bg-emerald-100 text-emerald-800 border-2 border-emerald-200 shadow-lg">
              <MapPin className="h-4 w-4 mr-2" />
              À seulement 200m des thermes
            </Badge>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight">
            Les 
            <span className="bg-gradient-to-r from-emerald-700 to-green-600 bg-clip-text text-transparent drop-shadow-sm"> Platanes</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed">
            Découvrez nos 11 appartements entièrement équipés, idéalement situés pour vos cures thermales et vacances de détente.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-12">
            <div className="flex items-center space-x-2 text-gray-700">
              <div className="flex text-yellow-400">
                <Star className="h-5 w-5 fill-current" />
                <Star className="h-5 w-5 fill-current" />
              </div>
              <span className="font-medium">Résidence 2 étoiles</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-700">
              <Waves className="h-5 w-5 text-green-600" />
              <span className="font-medium">Curistes & Vacanciers</span>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button 
              size="lg" 
              className="bg-gradient-to-r from-emerald-700 to-green-600 hover:from-emerald-800 hover:to-emerald-700 text-white px-10 py-4 text-lg font-semibold shadow-2xl hover:shadow-emerald-500/30 transition-all duration-500 border-2 border-emerald-600 hover:border-emerald-500 btn-hover-lift"
              onClick={() => scrollToSection('appartements')}
            >
              Découvrir nos appartements
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              className="border-2 border-emerald-700 text-emerald-700 hover:bg-emerald-50 hover:border-emerald-600 px-10 py-4 text-lg font-semibold transition-all duration-500 shadow-xl hover:shadow-emerald-500/20 btn-hover-lift"
              onClick={() => scrollToSection('contact')}
            >
              Demande de renseignements
            </Button>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-green-600 rounded-full p-1">
          <div className="w-1 h-3 bg-green-600 rounded-full mx-auto animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;